import React from 'react';
import MetaTags from 'react-meta-tags';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { AagencyForgot } from '../../apis/Agency';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { useState } from 'react';
import { successToast, ErrorToast } from '../../components/Toasts';
import { ToastContainer, toast } from 'react-toastify';
import './Common.css';

//M-Imports
// import  Box  from '@mui/material/Box';
import { Typography, TextField, Grid, Button } from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './Login.css';
import { base_url } from '../../apis/constants';

const ResetPassword = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [usernameOrEmail, setUsernameOrEmail] = useState('');

  const [isMailError, setIsMailError] = useState(false);
  const [mailError, setMailError] = useState(false);

  const handleSuccessResetPass = res => {
    setIsLoading(false);
    successToast(res.data.reasonPhrase);
    setTimeout(() => {
      history.push('/agency-signin');
    }, 1500);
    // history.push('/agency-signin');
  };

  const handleErrorResetPass = err => {
    setIsLoading(false);
    // ErrorToast(err.response.data.reasonPhrase);
    setIsMailError(true);
    setMailError(err.response.data.reasonPhrase);
  };
  const handleForgotPass = e => {
    setIsMailError(false);
    setMailError(false);
    setIsLoading(true);
    e.preventDefault();
    AagencyForgot(usernameOrEmail)
      .then(res => res.status === 200 && handleSuccessResetPass(res))
      .catch(err => handleErrorResetPass(err, 'AagencyForgot'));
  };
  return (
    <React.Fragment>
      <ToastContainer
        style={{ width: 'auto' }}
        position='top-center'
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className=''>
        <MetaTags>
          <title>Reset Password | TMS Shipping</title>
        </MetaTags>
        <section className='bg-auth' style={{ backgroundColor: '#ECEFF1' }}>
          <Container>
            <Grid
              container
              style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Grid
                item
                xs={12}
                sm={7}
                md={5}
                lg={4}
                xl={4}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <a href='/'>
                  <svg
                    width='202'
                    height='37'
                    class='my-3'
                    viewBox='0 0 356 73'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M19.7868 0.000359717L13.4229 6.36432L28.3075 21.2489C32.6032 25.5447 39.568 25.5447 43.8638 21.2489L58.7488 6.36398L52.3848 1.52588e-05L37.4998 14.885C36.7188 15.666 35.4525 15.666 34.6714 14.885L19.7868 0.000359717Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M72.1715 19.7867L65.8076 13.4227L50.923 28.3073C46.6272 32.6031 46.6272 39.5679 50.923 43.8637L65.8079 58.7486L72.1719 52.3847L57.2869 37.4997C56.5059 36.7187 56.5059 35.4524 57.2869 34.6713L72.1715 19.7867Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M19.7868 72.1713L13.4229 65.8073L28.3075 50.9227C32.6032 46.627 39.568 46.627 43.8638 50.9227L58.7487 65.8077L52.3848 72.1716L37.4998 57.2867C36.7188 56.5056 35.4525 56.5057 34.6714 57.2867L19.7868 72.1713Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M0.000342659 19.7867L6.3643 13.4227L21.2489 28.3074C25.5447 32.6031 25.5447 39.5679 21.2489 43.8637L6.36396 58.7486L-1.70308e-06 52.3847L14.8849 37.4997C15.666 36.7187 15.666 35.4524 14.8849 34.6713L0.000342659 19.7867Z'
                      fill='#3361FF'
                    />
                    <path
                      d='M94.7104 42.8213C95.7934 43.1905 96.9749 43.4859 98.2548 43.7074C99.5593 43.9043 100.852 44.0028 102.131 44.0028C103.879 44.0028 105.171 43.929 106.008 43.7813C106.87 43.609 107.436 43.3505 107.706 43.0059C107.977 42.6614 108.113 42.2183 108.113 41.6768C108.113 41.2092 108.014 40.84 107.817 40.5692C107.62 40.2985 107.239 40.0892 106.673 39.9416C106.107 39.7693 105.27 39.6339 104.162 39.5354L101.725 39.3139C99.9039 39.1416 98.464 38.7601 97.4056 38.1694C96.3718 37.5787 95.6334 36.791 95.1904 35.8065C94.772 34.7973 94.5628 33.5913 94.5628 32.1883C94.5628 30.5146 94.895 29.1608 95.5596 28.127C96.2488 27.0933 97.3564 26.3426 98.8824 25.8749C100.408 25.3826 102.439 25.1365 104.974 25.1365C108.273 25.1365 110.992 25.5672 113.134 26.4287L113.023 31.4499L112.912 31.5976C110.475 30.7361 107.928 30.3053 105.27 30.3053C103.99 30.3053 103.005 30.3792 102.316 30.5269C101.627 30.6499 101.147 30.8592 100.876 31.1545C100.605 31.4499 100.47 31.8683 100.47 32.4098C100.47 32.9513 100.556 33.3574 100.728 33.6282C100.925 33.8989 101.307 34.1081 101.873 34.2558C102.439 34.3789 103.264 34.502 104.347 34.625L106.673 34.8835C108.642 35.105 110.155 35.4988 111.214 36.0649C112.272 36.631 112.998 37.3941 113.392 38.354C113.811 39.2893 114.02 40.4338 114.02 41.7876C114.02 43.4367 113.663 44.815 112.949 45.9227C112.26 47.0057 111.128 47.8179 109.552 48.3594C107.977 48.9009 105.873 49.1716 103.239 49.1716C101.516 49.1716 99.9654 49.0855 98.5871 48.9132C97.2087 48.7163 95.8673 48.4579 94.5628 48.1379V42.9321L94.7104 42.8213ZM123.635 48.8394H117.727V25.4688H123.635V34.4035H132.496V25.4688H138.403V48.8394H132.496V39.2032H123.635V48.8394ZM148.729 48.8394H142.822V25.4688H148.729V48.8394ZM159.077 48.8394H153.169V25.4688H163.581C165.919 25.4688 167.79 25.7518 169.193 26.3179C170.596 26.8841 171.605 27.8071 172.22 29.087C172.836 30.3669 173.143 32.1021 173.143 34.2927C173.143 36.3603 172.836 38.0463 172.22 39.3508C171.605 40.6307 170.596 41.5784 169.193 42.1937C167.79 42.809 165.919 43.1167 163.581 43.1167H159.077V48.8394ZM162.621 30.3053H159.077V38.2801H162.621C164.369 38.2801 165.538 37.9848 166.129 37.3941C166.719 36.8033 167.015 35.7696 167.015 34.2927C167.015 32.8898 166.719 31.8806 166.129 31.2653C165.538 30.6253 164.369 30.3053 162.621 30.3053ZM192.149 48.8394V30.453H185.504V25.4688H204.702V30.453H198.057V48.8394H192.149ZM207.288 48.8394V25.4688H224.641V30.2684H213.195V34.6989H223.127V39.4985H213.195V44.0397H224.641V48.8394H207.288ZM245.013 43.7813V48.4332C243.832 48.6794 242.675 48.864 241.543 48.987C240.411 49.1101 239.069 49.1716 237.519 49.1716C235.525 49.1716 233.839 48.9994 232.461 48.6548C231.107 48.3102 230.011 47.7071 229.175 46.8457C228.362 45.9596 227.772 44.7166 227.402 43.1167C227.033 41.5168 226.849 39.4616 226.849 36.951C226.849 34.5389 227.033 32.5575 227.402 31.0068C227.772 29.4562 228.362 28.2624 229.175 27.4256C230.011 26.5641 231.107 25.9734 232.461 25.6534C233.839 25.3088 235.525 25.1365 237.519 25.1365C239.069 25.1365 240.411 25.198 241.543 25.3211C242.675 25.4196 243.832 25.6042 245.013 25.8749V30.6745L244.903 30.7484C243.869 30.5023 242.872 30.33 241.912 30.2315C240.952 30.1084 239.771 30.0469 238.368 30.0469C237.236 30.0469 236.3 30.1331 235.562 30.3053C234.848 30.453 234.282 30.7607 233.864 31.2284C233.445 31.696 233.15 32.3852 232.977 33.2959C232.83 34.2066 232.756 35.425 232.756 36.951C232.756 38.5509 232.83 39.8431 232.977 40.8276C233.15 41.7876 233.445 42.5137 233.864 43.0059C234.282 43.4982 234.848 43.8305 235.562 44.0028C236.3 44.1751 237.236 44.2612 238.368 44.2612C239.746 44.2612 240.915 44.2243 241.875 44.1505C242.86 44.052 243.844 43.8797 244.829 43.6336L245.013 43.7813ZM254.046 48.8394H248.138V25.4688H254.046V34.4035H262.907V25.4688H268.814V48.8394H262.907V39.2032H254.046V48.8394ZM290.209 48.8394H284.302V25.4688H294.713C297.051 25.4688 298.922 25.7518 300.325 26.3179C301.728 26.8841 302.737 27.8071 303.353 29.087C303.968 30.3669 304.276 32.1021 304.276 34.2927C304.276 36.3603 303.968 38.0463 303.353 39.3508C302.737 40.6307 301.728 41.5784 300.325 42.1937C298.922 42.809 297.051 43.1167 294.713 43.1167H290.209V48.8394ZM293.753 30.3053H290.209V38.2801H293.753C295.501 38.2801 296.67 37.9848 297.261 37.3941C297.851 36.8033 298.147 35.7696 298.147 34.2927C298.147 32.8898 297.851 31.8806 297.261 31.2653C296.67 30.6253 295.501 30.3053 293.753 30.3053ZM313.32 48.8394H307.413V25.4688H318.563C321.492 25.4688 323.621 26.1333 324.95 27.4625C326.304 28.767 326.981 30.6992 326.981 33.259C326.981 35.1788 326.501 36.8279 325.541 38.2063C324.581 39.56 323.313 40.4092 321.738 40.7538L321.701 40.8646C322.316 41.2584 322.993 41.9106 323.732 42.8213C324.47 43.732 325.196 44.7289 325.91 45.8119C326.648 46.8703 327.301 47.8671 327.867 48.8024V48.8394H321L317.012 42.9321C316.668 42.4152 316.385 42.046 316.163 41.8245C315.966 41.603 315.72 41.4676 315.425 41.4184C315.154 41.3691 314.711 41.3445 314.095 41.3445H313.32V48.8394ZM317.603 30.2684H313.32V36.5449H317.603C318.834 36.5449 319.683 36.2988 320.15 35.8065C320.643 35.3142 320.889 34.5143 320.889 33.4067C320.889 32.299 320.643 31.4991 320.15 31.0068C319.683 30.5146 318.834 30.2684 317.603 30.2684ZM330.471 37.1356C330.471 34.1574 330.803 31.7945 331.468 30.0469C332.157 28.2993 333.326 27.044 334.975 26.281C336.649 25.518 338.975 25.1365 341.953 25.1365C344.193 25.1365 346.051 25.3457 347.528 25.7641C349.005 26.1826 350.174 26.8594 351.035 27.7948C351.897 28.7301 352.5 29.9731 352.845 31.5237C353.214 33.0498 353.398 34.9204 353.398 37.1356C353.398 39.3754 353.214 41.2707 352.845 42.8213C352.5 44.3474 351.897 45.5781 351.035 46.5134C350.174 47.4487 349.005 48.1256 347.528 48.544C346.051 48.9624 344.193 49.1716 341.953 49.1716C339.713 49.1716 337.855 48.9624 336.378 48.544C334.901 48.1256 333.732 47.4487 332.871 46.5134C332.009 45.5781 331.394 44.3474 331.025 42.8213C330.655 41.2707 330.471 39.3754 330.471 37.1356ZM341.953 44.0028C343.528 44.0028 344.71 43.8059 345.497 43.4121C346.285 43.0183 346.814 42.3291 347.085 41.3445C347.356 40.3354 347.491 38.9324 347.491 37.1356C347.491 35.3634 347.356 33.9851 347.085 33.0005C346.814 32.016 346.285 31.3268 345.497 30.933C344.71 30.5146 343.528 30.3053 341.953 30.3053C340.402 30.3053 339.221 30.5146 338.409 30.933C337.621 31.3268 337.08 32.016 336.784 33.0005C336.513 33.9851 336.378 35.3634 336.378 37.1356C336.378 38.9324 336.513 40.3354 336.784 41.3445C337.08 42.3291 337.621 43.0183 338.409 43.4121C339.221 43.8059 340.402 44.0028 341.953 44.0028Z'
                      fill='#354463'
                    />
                  </svg>
                </a>

                <div class='login-form'>
                  <div class='w-100'>
                    <Typography variant='h4' class='login-welcome'>
                      Forgot Password?
                    </Typography>
                  </div>
                  <Typography variant='caption' class='login-info'>
                    Enter your email and we'll send you a reset link
                  </Typography>

                  <Form
                    className='auth-form'
                    fullWidth
                    style={{ width: '100%' }}
                  >
                    <div className='py-2'>
                      <TextField
                        fullWidth
                        id='email'
                        error={isMailError}
                        value={usernameOrEmail}
                        onChange={e => setUsernameOrEmail(e.target.value)}
                        label='Username or Email'
                        variant='standard'
                        required
                        helperText={mailError}
                      />
                    </div>

                    <div className='py-2'>
                      {/* <Button fullWidth variant="contained">LOGIN</Button> */}
                      <Button
                        fullWidth
                        disabled={usernameOrEmail ? false : true}
                        type='submit'
                        // className='btn btn-hover w-100'
                        variant='contained'
                        onClick={e => handleForgotPass(e)}
                      >
                        <div>
                          {isLoading ? (
                            <span style={{ display: 'inline-block' }}>
                              Loading ...
                            </span>
                          ) : (
                            <span style={{ display: 'inline-block' }}>
                              Send reset link
                            </span>
                          )}
                        </div>
                      </Button>
                    </div>

                    <div style={{ textAlign: 'end' }} className='py-3'>
                      Remembered it ?{' '}
                      <Link to='/agency-signin' style={{ color: '#3361FF' }}>
                        Go to Login
                      </Link>
                    </div>
                  </Form>
                </div>
              </Grid>
            </Grid>
          </Container>

          <div
            style={{ position: 'fixed', bottom: '8px' }}
            className='w-100 px-3'
          >
            <Grid
              container
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid
                item
                md={5}
                lg={5}
                class='login-footer-cols'
                style={{ display: 'flex' }}
              ></Grid>
              <Grid
                item
                md={6}
                lg={5}
                class='login-footer-cols'
                style={{ display: 'flex', justifyContent: 'end' }}
              >
                <div class='login-footer-notes'>
                  {/* Need Help?
                      <span class="login-footer-link1 mx-2">
                        <PhoneAndroidOutlinedIcon
                          style={{
                            height: 16,
                            width: 18
                          }}
                        />
                        <a class="login-footer-link1 "
                          href='tel:+1 120 279 53213'
                        >
                          +1 120 279 53213
                        </a>
                      </span> */}
                  <span class='login-footer-link1 mx-2'>
                    <div class='d-inline-block'>
                      <EmailOutlinedIcon
                        style={{
                          height: 16,
                          width: 18
                        }}
                      />
                      {base_url === 'https://api.tms.dynamicwerx.com/' ? (
                        <a
                          class='login-footer-link1'
                          href={'mailto:' + 'support@dynamicwerx.com'}
                        >
                          support@dynamicwerx.com
                        </a>
                      ) : (
                        <a
                          class='login-footer-link1'
                          href={'mailto:' + 'support@shiptechpro.com'}
                        >
                          support@shiptechpro.com
                        </a>
                      )}
                    </div>
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
